// Produzione — axios dedicato (token separato) + helper di formato e costanti
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const ALLOWED = ["production", "admin", "superadmin"];

export const prodApi = axios.create({ baseURL: API });
prodApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("prod_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const num = (v) => {
  const n = parseFloat(String(v ?? "").replace(",", "."));
  return Number.isFinite(n) ? n : 0;
};
export const fmtKg = (n, d = 2) => (n ?? 0).toLocaleString("it-IT", { minimumFractionDigits: d, maximumFractionDigits: d });
export const fmtEur = (n, d = 2) => (n == null ? "—" : (Math.abs(n) < 0.005 ? 0 : n).toLocaleString("it-IT", { minimumFractionDigits: d, maximumFractionDigits: d }) + " €");
export const fmtPct = (n, d = 1) => (n == null ? "—" : n.toLocaleString("it-IT", { minimumFractionDigits: d, maximumFractionDigits: d }) + " %");
export const fmtDate = (d) => (d ? d.slice(0, 10).split("-").reverse().join("/") : "—");
export const today = () => new Date().toISOString().slice(0, 10);
export const errMsg = (e, fallback = "Operazione non riuscita") => e?.response?.data?.detail || fallback;
export const outKey = (o) => `${o.node_id}|${o.trim_level_id || ""}`;

export const METHODS = [
  { value: "average", label: "Costo medio", hint: "A · stesso costo €/kg per ogni kg vendibile" },
  { value: "weighted", label: "Coefficienti", hint: "B · costo ripartito per kg × coefficiente economico (pregio), modificabile per riga" },
  { value: "nrv", label: "Valore mercato", hint: "C · in proporzione a kg × prezzo di riferimento di mercato (se manca, prezzo di vendita)" },
  { value: "custom", label: "Personalizzato", hint: "D · blocca costo €/kg o % del costo sulle righe che vuoi; il resto si ripartisce per coefficienti" },
];
export const GRADES = [
  { value: 1, label: "1 · Pregiato", coeff: 1.6 },
  { value: 2, label: "2 · Alto", coeff: 1.3 },
  { value: 3, label: "3 · Medio", coeff: 1.0 },
  { value: 4, label: "4 · Base", coeff: 0.8 },
];
export const PCT_SOURCES = [
  { value: "stimata", label: "Stimata", short: "stim." },
  { value: "storica", label: "Storica", short: "stor." },
  { value: "misurata", label: "Misurata", short: "mis." },
];
export const PRICE_MODES = [
  { value: "kg", label: "€/kg" },
  { value: "piece", label: "€/pezzo" },
  { value: "lot", label: "€/lotto" },
];
export const DISPOSALS = [
  { value: "sellable", label: "Vendibile" },
  { value: "process", label: "Altra lavorazione" },
  { value: "reuse", label: "Riutilizzo" },
  { value: "byproduct", label: "Sottoprodotto" },
  { value: "waste", label: "Scarto" },
];
export const SELL = ["sellable", "process", "reuse"];
export const KINDS = [
  { value: "meat", label: "Carne / taglio" },
  { value: "processed", label: "Trasformato" },
  { value: "byproduct", label: "Sottoprodotto" },
  { value: "waste", label: "Scarto" },
];
export const BASES = [
  { value: "per_piece", label: "per pezzo" },
  { value: "per_kg_input", label: "per kg in ingresso" },
  { value: "per_kg_output", label: "per kg vendibile" },
  { value: "per_run", label: "per lavorazione" },
];
export const labelOf = (list, v) => list.find((x) => x.value === v)?.label || v || "—";
